"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSubHeader = exports.StyledLink = exports.StyledCancelButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactstrap = require("reactstrap");
var _Button = require("../Button");
var _templateObject, _templateObject2, _templateObject3;
var StyledSubHeader = exports.StyledSubHeader = (0, _styledComponents["default"])(_reactstrap.FormText)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 0;\n  margin-bottom: 10px;\n"])));
var StyledLink = exports.StyledLink = _styledComponents["default"].a(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: blue;\n  margin-left: 5px;\n  text-decoration: underline;\n"])));
var StyledCancelButton = exports.StyledCancelButton = (0, _styledComponents["default"])(_Button.Button)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n"])));